export const EDIT_CREATE_SURVEYS = 'EDIT_CREATE_SURVEYS';
